import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
} from 'assets/jss/material-dashboard-pro-react.jsx';

const cardTextStyle = {
  cardText: {
    float          : 'none',
    display        : 'inline-block',
    marginRight    : '0',
    borderRadius   : '3px',
    backgroundColor: '#999999',
    padding        : '15px',
    marginTop      : '-20px',
  },
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
};

export default cardTextStyle;
